import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TermsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 bg-gray-50" style={{ paddingTop: '120px', paddingBottom: '80px' }}>
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 sm:p-12">
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-8">Terms of Service</h1>

            <div className="prose prose-gray max-w-none">
              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Agreement to Terms</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  By accessing or using FlightClaim's services, you agree to be bound by these Terms of Service. 
                  If you disagree with any part of these terms, you may not access our services.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Description of Services</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  AirDelayClaim provides flight delay compensation claim services. We assist passengers in claiming 
                  compensation under EU Regulation 261/2004 and UK Regulation 261/2004 for delayed, cancelled, 
                  or overbooked flights.
                </p>
                <ul className="list-disc pl-6 text-gray-600 space-y-2">
                  <li>Eligibility assessment for flight compensation claims</li>
                  <li>Document collection and claim submission</li>
                  <li>Communication with airlines on your behalf</li>
                  <li>Legal proceedings if necessary</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">3. Fee Structure</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Our services operate on a "No Win, No Fee" basis. You will only be charged if your claim is successful.
                </p>
                <ul className="list-disc pl-6 text-gray-600 space-y-2">
                  <li>Success fee: 25% of the compensation amount (plus applicable VAT)</li>
                  <li>No upfront costs or hidden fees</li>
                  <li>Payment is deducted from your compensation before transfer</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">4. User Responsibilities</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  When using our services, you agree to:
                </p>
                <ul className="list-disc pl-6 text-gray-600 space-y-2">
                  <li>Provide accurate and complete information about your flight</li>
                  <li>Not submit fraudulent or false claims</li>
                  <li>Cooperate with document requests in a timely manner</li>
                  <li>Not engage with airlines independently once a claim is submitted</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Limitation of Liability</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  AirDelayClaim shall not be liable for any indirect, incidental, special, consequential, or punitive 
                  damages resulting from your use of our services. Our total liability shall not exceed the amount 
                  of fees paid by you for the specific claim in question.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">6. Governing Law</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  These Terms shall be governed by and construed in accordance with the laws of England and Wales, 
                  without regard to its conflict of law provisions.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">7. Contact Information</h2>
                <p className="text-gray-600 leading-relaxed">
                  For questions about these Terms, please contact us at{' '}
                  <a href="mailto:info@airdelayclaim.com" className="text-blue-600 hover:underline">
                    info@airdelayclaim.com
                  </a>
                </p>
              </section>
            </div>

            <div className="mt-12 pt-8 border-t border-gray-200">
              <Link 
                to="/" 
                className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium"
              >
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
                Back to Home
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsPage;
